import { useMutation } from "@tanstack/react-query";
import { certLgnPwdApi } from "components/api/member";
import Step4View from "components/view/resetpw/step4";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useMatch, useNavigate } from "react-router-dom";
import { setMessage } from "store/commonSlice";

const Step4Page = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname, search, state } = useLocation();
  const [info, setInfo] = useState({
    pwd: "",
    pwd_chk: "",
  });

  const handleChange = (name: string, value: string) => {
    setInfo({
      ...info,
      [name]: value,
    });
  };

  const restPwdMuataion = useMutation(certLgnPwdApi, {
    onSuccess(data) {
      if (data) {
        const {
          header: { code, message },
          body,
        } = data;
        if (code === 0) {
          dispatch(
            setMessage({
              message: "비밀번호 설정이 완료되었습니다.",
              cnfrmBtnText: "로그인",
              isConfirm: true,
              handleClick() {
                dispatch(setMessage({ message: null }));
                navigate("/", {
                  replace: true,
                });
                // window.location.replace("/");
              },
            })
          );
        }
        if (code === -1) {
          dispatch(setMessage({ message }));
        }
      }
    },
  });

  const handleSetting = () => {
    restPwdMuataion.mutate({
      certEncParam: search?.replace("?param=", ""),
      newLgnPwd: info.pwd,
    });
  };

  return (
    <Step4View
      info={info}
      isLoading={restPwdMuataion.isLoading}
      handleChange={handleChange}
      handleSetting={handleSetting}
    />
  );
};

export default Step4Page;
